import React from 'react';



const Pagination = ({
  pageNumber = 1,
  totalPages ,
  onPageChange 
} : any) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedPage = parseInt(event.target.value, 10);
    onPageChange(selectedPage);
  
    // Perform any action on page change, like fetching data for the selected page.
    console.log(`Navigated to page: ${selectedPage}`);
  };

  if (totalPages <= 1) return null;

  return (
    <div className="pagination-controls">
      <button
        type="button"
        onClick={() => onPageChange(pageNumber - 1)}
        disabled={pageNumber <= 1}
        aria-label="Go to previous page"
      >
        Previous
      </button>
      <label htmlFor="pagination-dropdown">Page</label>
      <select
        id="pagination-dropdown"
        value={pageNumber}
        onChange={handlePageChange}
        aria-label="Select a page"
        title="Select a page"
      >
        {Array.from({ length: totalPages }, (_, index) => (
          <option key={index + 1} value={index + 1}>
            {index + 1}
          </option>
        ))}
      </select>
      <span>of {totalPages}</span>
      <button
        type="button"
        onClick={() => onPageChange(pageNumber + 1)}
        disabled={pageNumber >= totalPages}
        aria-label="Go to next page"
      >
        Next
      </button>
      {/* <button 
        className='bg-[#DBDBDB] rounded mt-1 mx-1' 
        onClick={() => onPageChange(pageNumber - 1)}
        disabled={pageNumber === 1}
        aria-label='Previous'>
        <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"/></svg>
      </button>
      {pageNumbers.map(num => (
        <button
          key={num}
          className={`text-xl mx-2 ${pageNumber === num ? 'font-bold' : ''}`}
          onClick={() => onPageChange(num)}
          aria-label={'page'+ num}
        >
          {num}
        </button>
      ))}
      <button 
        className='bg-[#DBDBDB] rounded mt-1 mx-1'
        onClick={() => onPageChange(pageNumber + 1)}
        disabled={pageNumber === totalPages}
        aria-label='Next'>
        <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"/></svg>
      </button> */}
    </div>
  );
};

export default Pagination;
